export const COUNTED_SHIFT_TYPES = new Set([1, 2, 3]);

export function toIsoDate(value) {
  if (!value) return "";
  if (typeof value === "string") return value.slice(0, 10);
  try {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  } catch (err) {
    return "";
  }
}

export function addDaysIso(iso, days) {
  const parsed = toIsoDate(iso);
  if (!parsed) return "";
  const [year, month, day] = parsed.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  date.setDate(date.getDate() + days);
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function isCountedChkShift(shift) {
  return Boolean(shift) && COUNTED_SHIFT_TYPES.has(Number(shift.type_shift_id));
}

export function shiftHours(shift) {
  return Number(shift?.hours) || 0;
}

export function isShiftInWeek(shift, weekDates) {
  if (!weekDates?.length) return false;
  const iso = toIsoDate(shift?.date);
  return weekDates.some((day) => toIsoDate(day) === iso);
}

export function countedShiftsInWeek(shifts, weekDates) {
  return (shifts || []).filter(
    (shift) => isCountedChkShift(shift) && isShiftInWeek(shift, weekDates),
  );
}

export function hoursByEmployeeFromShifts(shifts, weekDates) {
  const hours = {};
  for (const shift of countedShiftsInWeek(shifts, weekDates)) {
    const id = Number(shift.employee);
    if (!id) continue;
    hours[id] = (hours[id] || 0) + shiftHours(shift);
  }
  return hours;
}

export function weekdayIndexInWeek(dateString, weekDates = []) {
  const iso = toIsoDate(dateString);
  if (!iso) return -1;
  return weekDates.findIndex((day) => toIsoDate(day) === iso);
}

export function isOvernightShift(shift) {
  const start = Number(shift?.start);
  const end = Number(shift?.end);
  return Number.isFinite(start) && Number.isFinite(end) && end > 0 && end <= start;
}

export function weekStartOvernightRemainder(shift, weekDates) {
  if (!weekDates?.length || !isOvernightShift(shift)) return null;
  const weekStart = toIsoDate(weekDates[0]);
  if (toIsoDate(shift.date) !== addDaysIso(weekStart, -1)) return null;
  const end = Number(shift.end);
  if (end <= 0) return null;
  return { dayIndex: 0, startHour: 0, endHour: end, duration: end };
}

export function formatChkHours(value, digits = 1) {
  return (Number(value) || 0).toLocaleString("ru-RU", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function dayFactHours(employee, dayIndex) {
  const value = Number(employee?.fact_hours?.[dayIndex]);
  if (!Number.isFinite(value) || value <= 0) return 0;
  return value;
}

export function sumFactHours(factHours) {
  let total = 0;
  for (const value of factHours || []) {
    const hours = Number(value) || 0;
    if (hours > 0) total += hours;
  }
  return Math.round(total * 10) / 10;
}
